import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import TextField from '@material-ui/core/TextField';

import { MdWarning as WarningIcon } from 'react-icons/md';
import { connect } from 'react-redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import * as notifications from 'actions/notificationActions';

import { AccentColor } from 'helpers/AccentColorHelper';

export default connect(
  (store) => {
    return {
      userType: store.userTypes.loginAuth,
      landlordId: store.userTypes.landlordId,
    };
  },
  (dispatch) => {
    return {
      showSuccess: (message) => {
        dispatch(notifications.showSuccess(message));
      },
    };
  }
)(
  class ResendConfirmation extends Component {
    constructor(props) {
      super(props);
      this.state = { email: '', errorMessage: null, buttonEnabled: true };
      this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
      this.setState({ [event.target.name]: event.target.value.trim() });
    }

    ResendConfirmationEmail = () => {
      this.setState({ buttonEnabled: false });
      let auth_type = 'leads';
      if (this.props.userType === 'maintenance') {
        auth_type = 'maintenance';
      } else if (this.props.userType === 'landlord') {
        auth_type = 'landlords';
      }
      fetch(`http://api.localhost/v1/${auth_type}/send_email_confirmation`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.state.email,
          landlord_id: this.props.landlordId,
        }),
        type: 'cors',
      })
        .then((result) => {
          result
            .text()
            .then((result) => {
              if (result.includes('confirmation instructions')) {
                this.props.showSuccess(JSON.parse(result).message[0]);
                this.setState({ email: '', errorMessage: null });
              } else {
                this.setState({
                  errorMessage: (
                    <p>
                      <WarningIcon /> &nbsp; {JSON.parse(result).message[0]}
                    </p>
                  ),
                });
              }
              this.setState({ buttonEnabled: true });
            })
            .catch((error) => {
              let errorMessage = {};
              if (error.data) {
                errorMessage = {
                  errorMessage: (
                    <p>
                      <WarningIcon /> {error.data.errors[0]}
                    </p>
                  ),
                };
              } else {
                errorMessage = {
                  errorMessage: (
                    <p>
                      <WarningIcon /> Woops! Something is not quite right. Please try again later.
                    </p>
                  ),
                };
              }
              this.setState({ ...errorMessage, buttonEnabled: true });
              console.error(error);
            });
        })
        .catch((error) => {
          let errorMessage = {};
          if (error.data) {
            errorMessage = {
              errorMessage: (
                <p>
                  <WarningIcon /> {error.data.errors[0]}
                </p>
              ),
            };
          } else {
            errorMessage = {
              errorMessage: (
                <p>
                  <WarningIcon /> Woops! Something is not quite right. Please try again later.
                </p>
              ),
            };
          }
          this.setState({ ...errorMessage, buttonEnabled: true });
          console.error(error);
        });
    };

    render() {
      const style = {
        button: {
          marginTop: '20px',
          width: '100%',
          color: 'white',
          fontSize: '16px',
          height: '50px',
        },
        email_field: {
          marginTop: '-20px',
          fontSize: '14px',
        },
        transactionCard: {
          color: '#424242 !important',
          fontFamily: '"Circular", sans-serif !important',
          height: '100%',
          overflow: 'hidden',
          borderRadius: '8px',
          padding: '15px',
          marginTop: '15px',
        },
      };

      return (
        <div style={{ marginTop: '20px', maxWidth: '320px', minWidth: '300px' }}>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div>
                <h3 style={{ padding: '0 0 10px' }}>Resend Confirmation</h3>
                <div className="error-message">{this.state.errorMessage}</div>
              </div>
              <div className="row" style={{ textAlign: 'left' }}>
                <TextField
                  name="email"
                  label="email"
                  floatingLabelText="Email"
                  onChange={this.handleInputChange}
                  value={this.state.email}
                  onKeyDown={this.detectEnterKeyDown}
                  variant="outlined"
                  style={{ marginTop: '5px' }}
                />
              </div>
              <FlatButton
                name="submit"
                label="send"
                primary={true}
                onClick={this.ResendConfirmationEmail}
                disabled={!this.state.buttonEnabled}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
              <div id="account-links-container">
                {this.props.userType === 'landlord' && (
                  <p className="account-link">
                    <a href="/companies">Already a member?</a>
                  </p>
                )}
                {this.props.userType === 'maintenance' && (
                  <p className="account-link">
                    <a href="/maintenance">Already a member?</a>
                  </p>
                )}
                {this.props.userType !== 'landlord' && this.props.userType !== 'maintenance' && (
                  <p className="account-link">
                    <a href="/">Already a member?</a>
                  </p>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }
  }
);
